import { Component, Input } from '@angular/core';
import { GymUtils } from '../../../util/gym-util';

@Component({
  selector: 'gymfinder-changelog-options',
  templateUrl: './changelog-options.component.html',
  styleUrls: ['./changelog-options.scss'],
  standalone: false,
})
export class ChangelogOptionsComponent {
  @Input()
  options: any[];

  @Input()
  fieldType: 'activities' | 'services';

  getTranslation = () => GymUtils.getOptionsTranslation(this.fieldType);
}
